<template>
  <!--
    CONTRIBUIR PARA O CAIXA, em papel. Os atalhos são degraus rápidos; o campo é DIGITÁVEL como o
    contador da loja (pedido do autor de 02/09 vale aqui também: quem quer dar 12.345 digita). O
    botão mostra o número que vai sair do bolso — é dinheiro, não pode haver surpresa (D11).
  -->
  <FishModal :aberto="true" :titulo="$t('clan.contribute')" @fechar="$emit('close')">
    <!-- O porquê de contribuir, de volta (o autor cobrou: o modal antigo explicava). -->
    <p class="contribuir__conversa">{{ $t('clan.contributeInfo') }}</p>

    <p class="contribuir__saldo">
      <FishIcon nome="coins" tamanho="pequeno" />
      <!-- A chave `clan.yourGold` já termina em dois-pontos — nada de somar outro. -->
      {{ $t('clan.yourGold') }} <strong class="t-numero">{{ formato(maxAmount) }}</strong>
    </p>

    <div class="contribuir__degraus">
      <FishButton
        v-for="degrau in degraus"
        :key="degrau"
        tamanho="pequeno"
        :variante="quantia === degrau ? 'primario' : 'neutro'"
        :desabilitado="degrau > maxAmount"
        som="clique"
        @click="quantia = degrau"
      >
        {{ formato(degrau) }}
      </FishButton>
    </div>

    <label class="contribuir__campo">
      <span class="t-legenda">{{ $t('clan.customAmount') }}</span>
      <input
        type="number"
        min="1"
        :max="maxAmount"
        :value="quantia"
        @input="digitar($event)"
      >
    </label>

    <!-- O que o doador leva: a conversão em moedas de clã, viva conforme digita. -->
    <p class="contribuir__moedas">
      <FishIcon nome="clan-bau" tamanho="pequeno" />
      {{ $t('clan.youWillReceive') }}
      <strong class="t-numero">{{ formato(moedasQueRecebe) }}</strong>
      {{ $t('clan.clanCoins') }}
    </p>

    <template #acoes>
      <FishButton
        variante="primario"
        bloco
        :desabilitado="!quantiaValida"
        :motivo="motivo"
        som="compra"
        @click="$emit('contribute', quantia)"
      >
        {{ $t('clan.contributeButton') }} · {{ formato(quantia) }}
      </FishButton>
    </template>
  </FishModal>
</template>

<script>
import { FishModal, FishButton, FishIcon } from '@/shared/ui';

export default {
  name: 'ContributeModal',
  components: { FishModal, FishButton, FishIcon },
  props: {
    maxAmount: {
      type: Number,
      default: 0
    }
  },
  emits: ['close', 'contribute'],
  data() {
    return {
      quantia: 1000,
      degraus: [1000, 5000, 10000, 50000],
    };
  },
  computed: {
    quantiaValida() {
      return Number.isFinite(this.quantia) && this.quantia >= 1 && this.quantia <= this.maxAmount;
    },
    /**
     * Espelho de `moedasPorContribuicao` do `@fishbay/domain` (1 por 100 de gold).
     * Quem CREDITA é o servidor; isto é só a previsão da tela. Se a fórmula de lá
     * mudar, esta muda junto — é o par que o CLAUDE.md manda manter colado.
     */
    moedasQueRecebe() {
      return this.quantiaValida ? Math.floor(this.quantia / 100) : 0;
    },
    motivo() {
      if (this.quantia > this.maxAmount) return this.$t('clan.notEnoughGold');
      return '';
    },
  },
  methods: {
    formato(n) {
      return new Intl.NumberFormat('pt-BR').format(n || 0);
    },
    digitar(evento) {
      const bruto = parseInt(evento.target.value, 10);
      this.quantia = Number.isFinite(bruto) ? Math.max(1, bruto) : 1;
    },
  },
};
</script>

<style scoped>
.contribuir__conversa {
  margin: 0 0 var(--e-3);
  font-size: var(--f-1);
  color: var(--tinta-fraca);
}

.contribuir__moedas {
  margin: var(--e-3) 0 0;
  display: flex;
  align-items: center;
  gap: var(--e-1);
  padding-top: var(--e-2);
  border-top: 2px dashed var(--papel-sombra);
  font-size: var(--f-2);
  color: var(--tinta);
}

.contribuir__moedas strong {
  color: var(--latao);
  font-size: var(--f-3);
}

.contribuir__saldo {
  margin: 0 0 var(--e-3);
  display: flex;
  align-items: center;
  gap: var(--e-1);
  font-size: var(--f-2);
  color: var(--tinta);
}

.contribuir__saldo strong {
  color: var(--latao);
}

.contribuir__degraus {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--e-2);
  margin-bottom: var(--e-3);
}

.contribuir__campo {
  display: flex;
  flex-direction: column;
  gap: var(--e-1);
  color: var(--tinta-fraca);
}

/* O mesmo papel rebaixado do contador da loja, com os spinners escondidos. */
.contribuir__campo input {
  border: 2px solid var(--madeira);
  background: var(--papel-frio);
  padding: var(--e-2);
  font-family: var(--fonte-corpo);
  font-size: var(--f-3);
  color: var(--tinta);
  -moz-appearance: textfield;
  appearance: textfield;
}

.contribuir__campo input::-webkit-outer-spin-button,
.contribuir__campo input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.contribuir__campo input:focus {
  outline: 2px solid var(--latao);
  outline-offset: -2px;
}
</style>
